import { useEffect } from 'react';
import { OnValueChange } from 'types/global';

export const useSettingsChange = <T>({ value, onChange }: OnValueChange<T>) => {
  useEffect(() => {
    onChange(value);
  }, [value, onChange]);
};
